import type { SVGProps } from 'react';

const SvgRssFeed = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="rss-feed">
      <path d="M.64 3.14v25.72a2.65 2.65 0 0 0 2.65 2.65h25.42a2.65 2.65 0 0 0 2.65-2.65V3.14A2.65 2.65 0 0 0 28.71.49H3.29A2.65 2.65 0 0 0 .64 3.14m29.28 0v25.72a1.21 1.21 0 0 1-1.21 1.21H3.29a1.21 1.21 0 0 1-1.21-1.21V3.14a1.21 1.21 0 0 1 1.21-1.21h25.42a1.21 1.21 0 0 1 1.21 1.21" />
      <path d="M24.31 26.27h1.44A19.65 19.65 0 0 0 6.12 6.65v1.44a18.2 18.2 0 0 1 18.19 18.18" />
      <path d="M18.36 26.27h1.44A13.69 13.69 0 0 0 6.12 12.59V14a12.25 12.25 0 0 1 12.24 12.27M9.21 27a3.81 3.81 0 1 0-3.81-3.82A3.82 3.82 0 0 0 9.21 27m0-6.17a2.37 2.37 0 1 1-2.37 2.36 2.37 2.37 0 0 1 2.37-2.37Z" />
    </g>
  </svg>
);

export default SvgRssFeed;
